import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'y_coord',
    dependencies: [
        'levels_maths/simple_length'
    ]
})


function common (q, {a, showUselessB}) {
    a.name = 'A'


    let geoScreen = q.addGeoScreen()
    geoScreen.addPoint(a)

    if (showUselessB) {
        let b = {
            x: a.x + random.fairChoiceInt(2, 4, {name: 'bx'}),
            y: a.y + random.fairChoiceInt(2, 6, {name: 'by'}),
            name: 'B',
            color: '#226ea5'
        }

        geoScreen.addPoint(b)
    }

    q.addText(mathText.pointY(a) + ' = ?')
    q.answer = a.y
}


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: {
                x: random.fairChoiceInt(1, 5, {name: 'x'}),
                y: random.fairChoiceInt(1, 7, {name: 'y'})
            }
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            a: {
                x: random.fairChoiceInt(0, 6,   {name: 'x'}),
                y: random.fairChoiceInt(-5, -1, {name: 'y'})
            },
            showUselessB: true
        })
    }
})




export default level

